<!-- Barras de Título e Ações permanecem inalteradas -->
<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>{{tipoOperacao}} Parcela</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar"><mat-icon>fullscreen_exit</mat-icon></button>
      <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir"><mat-icon>fullscreen</mat-icon></button>
      <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar"><mat-icon>close</mat-icon></button>
    </div>
  </div>
</mat-toolbar>

<div mat-dialog-actions>
  <button mat-raised-button color="primary" matTooltip="Salvar" (click)="salvar()" *ngIf="permiteEdicao || permiteEditarDescricao">
    <mat-icon>save</mat-icon>
  </button>
  <button mat-raised-button [matMenuTriggerFor]="opcoes" matTooltip="Opções">
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #opcoes>
    <button mat-menu-item *ngIf="contaParcelaForm.get('contaParcelaId')?.value > 0"
      (click)="abreModalConta(contaParcelaForm.get('contaId')?.value)">
      <mat-icon>edit</mat-icon> Conta
    </button>
    <button mat-menu-item *ngIf="contaParcelaForm.get('caixaMovimentoId')?.value > 0" (click)="caixaMovimentoModal()">
      <mat-icon>edit</mat-icon> Lançamento no Caixa
    </button>
    <button mat-menu-item *ngIf="contaParcelaForm.get('statusPagamento')?.value == 0" (click)="baixarParcela(contaParcelaForm.get('contaParcelaId')?.value, contaParcelaForm.get('numeroParcelas')?.value)">
      <mat-icon>attach_money</mat-icon> Baixar
    </button>
    <button mat-menu-item *ngIf="contaParcelaForm.get('statusPagamento')?.value < 2 && boleto.status != 1 && boleto.status != 2" (click)="cancelarParcela(contaParcelaForm.value)"
      color="warn">
      <mat-icon>delete</mat-icon> Cancelar
    </button>
    <button mat-menu-item *ngIf="podeSubstituir"
      [matMenuTriggerFor]="switchMenu">
      <mat-icon>compare_arrows</mat-icon> Substituir Parcela
    </button>
    <button mat-menu-item *ngIf="contaParcelaForm.get('contaParcelaId')?.value > 0" (click)="abreModalAnexo()"><mat-icon>attach_file</mat-icon> Anexos</button>
    <button mat-menu-item *ngIf="contaParcelaForm.get('contaParcelaId')?.value > 0" (click)="abrirLogs()"><mat-icon>app_registration</mat-icon>Logs</button>
    <button mat-menu-item *ngIf="contaParcelaForm.get('contaCorrenteVendaId')?.value > 0"
      (click)="contaCorrenteVendaModal(contaParcelaForm.get('contaCorrenteVendaId')?.value)">
      <span class="fa fa-card"></span> Lançamento Cartão</button>
  </mat-menu>
</div>

<!-- Conteúdo do Diálogo com layout de colunas independentes -->
<mat-dialog-content class="dialog-content-area-flat">
  <form [formGroup]="contaParcelaForm">

    <div class="dashboard-columns">

      <!-- COLUNA DA ESQUERDA -->
      <div class="column-left">

        <!-- CARD: Informações Gerais -->
        <div class="info-section">
          <div class="section-header">
            <mat-icon class="section-icon normal-icon">info</mat-icon>
            <span class="section-title">Informações Gerais</span>
          </div>
          <div class="section-content">
            <div class="row">
              <div class="col-md-5 col-sm-5">
                <div class="field-group">
                  <label class="field-label">Status</label>
                  <div class="status-tag" [ngClass]="'status-' + contaService.corStatusPagamento(this.contaParcela).toLowerCase()">
                    {{contaService.corStatusPagamento(this.contaParcela)}}
                  </div>
                </div>
              </div>
              <div class="col-md-7 col-sm-7">
                <div class="field-group">
                  <p>
                    <label class="field-label">Data Criação</label>
                    {{ contaParcelaForm.get('dataCriacao').value | date: 'dd/MM/yyyy' }}
                  </p>
                </div>
              </div>
              <div class="col-md-12">
                <mat-form-field class="full-width-field">
                  <mat-label>Descrição da Parcela</mat-label>
                  <textarea matInput formControlName="descricao" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5"></textarea>
                </mat-form-field>
              </div>
              <div class="col-md-12" *ngIf="contaParcelaForm.get('caixaId')?.value > 0">
                <mat-form-field class="full-width-field">
                  <mat-label>Caixa (Fluxo de Caixa)</mat-label>
                  <input matInput [value]="caixaDescricao" disabled>
                </mat-form-field>
              </div>

            </div>
          </div>
        </div>

        <!-- CARD: Informações do Boleto (Sobe se houver espaço) -->

        <div>
          <div class="info-section tax-information">
            <div class="section-header">
              <div [ngStyle]="{ 'cursor': nfse?.nfseId <= 0 ? 'no-drop' : 'pointer' }"
                  (click)="visualizaNfse(contaParcela)"
                  [ngClass]="nfseService.corStatus(nfse?.statusProcessamento) + ' ' + (nfse?.nfseId > 0 ? 'rps' : '')">
                <mat-icon class="section-icon" fontSet="material-symbols-outlined">receipt_long</mat-icon>
              </div>
              <span class="section-title">Informações Fiscais</span>
            </div>
            <div class="section-content fiscal-details">
              <mat-form-field class="col-md-12 col-xs-12 form-group">
                <mat-label>Tipo de Documento Fiscal</mat-label>
                <mat-select formControlName="documentoFiscal">
                  <mat-option [value]="1">Nfs-e</mat-option>
                  <mat-option [value]="2">Recibo</mat-option>
                  <mat-option [value]="3">Nf-e</mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </div>
        </div>

      </div>

      <!-- COLUNA DA DIREITA -->
      <div class="column-right">

        <!-- CARD: Valores e Prazos OU Informações de Pagamento -->
        <!-- Caso: Parcela NÃO Quitada -->
        <div class="info-section" *ngIf="contaParcela.statusPagamento != 1">
          <div class="section-header">
            <mat-icon class="section-icon normal-icon">calendar_today</mat-icon>
            <span class="section-title">Valores e Prazos</span>
          </div>
          <div class="section-content">
            <div *ngIf="edicaoValorVencimentoBloqueada" class="aviso-valor-vencimento">
              <mat-icon class="aviso-valor-vencimento-icone">info</mat-icon>
              A edição de <strong>valor</strong> e <strong>data de vencimento</strong> foi <strong>desativada por tempo indeterminado pelo banco emissor (Bradesco)</strong> para boletos já emitidos via API. Para alterar, cancele este boleto e emita um novo.
            </div>
            <mat-form-field class="full-width-field">
              <mat-label>Valor da Parcela</mat-label>
              <input currencyMask matInput formControlName="valorParcela" class="text-right" [readonly]="edicaoValorVencimentoBloqueada">
            </mat-form-field>
            <mat-form-field class="full-width-field">
              <mat-label>Data de Vencimento</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="dataVencimento" [readonly]="edicaoValorVencimentoBloqueada">
              <mat-datepicker-toggle matSuffix [for]="picker1" [disabled]="edicaoValorVencimentoBloqueada"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>

            <div *ngIf="contaParcela.statusPagamento != 1">
              <mat-form-field class="full-width-field">
                <mat-label>Forma de Pagamento</mat-label>
                <mat-select formControlName="tipoPagamento">
                  <mat-option *ngFor="let opcao of opcoesTipoPagamento" [value]="opcao.valor">
                    {{ opcao.texto }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </div>

        <!-- Caso: Parcela QUITADA -->
        <div class="info-section" *ngIf="contaParcela.statusPagamento == 1">
          <div class="section-header">
            <mat-icon class="section-icon normal-icon">payments</mat-icon>
            <span class="section-title">Informações de Pagamento</span>
          </div>
          <div class="section-content pagamento-details">
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <p><label class="field-label">Valor da Parcela</label> {{contaParcelaForm.get('valorParcela').value ?? 0 | currency: 'BRL'}} </p>
              </div>
              <div class="col-md-6 col-xs-12">
                <p><label class="field-label">Valor Pago</label> {{contaParcelaForm.get('valorPagamento').value ?? 0 | currency: 'BRL'}} </p>
              </div>
              <div class="col-md-6 col-xs-12">
                <p><label class="field-label">Data de Vencimento</label> {{contaParcelaForm.get('dataVencimento').value | date: 'dd/MM/yyyy'}} </p>
              </div>
              <div class="col-md-6 col-xs-12">
                <p><label class="field-label">Data de Pagamento</label> {{contaParcelaForm.get('dataPagamento').value | date: 'dd/MM/yyyy'}} </p>
              </div>
              <div *ngIf="contaParcelaForm.get('tipoPagamento').value == 2" class="col-md-6 col-xs-12">
                <p><label class="field-label">Número de Parcelas</label> {{contaParcelaForm.get('numeroParcelas').value}} </p>
              </div>
              <div class="col-md-6 col-xs-12">
                <p><label class="field-label">Valor do Desconto</label> {{contaParcelaForm.get('valorDescontoPago').value ?? 0 | currency: 'BRL'}} </p>
              </div>
              <div class="col-md-6 col-xs-12">
                <p><label class="field-label">Valor do Juros</label> {{contaParcelaForm.get('valorJurosPago').value ?? 0 | currency: 'BRL'}} </p>
              </div>
              <div class="col-md-6 col-xs-12">
                <p><label class="field-label">Valor da Multa</label> {{contaParcelaForm.get('valorMultaPago').value ?? 0 | currency: 'BRL'}} </p>
              </div>

              <ng-container *ngIf="isCartaoQuitado">
                <div class="col-md-6 col-xs-12">
                  <p><label class="field-label">Valor Retido</label> {{ valorTaxa | currency: 'BRL'}} </p>
                </div>
                <div class="col-md-6 col-xs-12">
                  <p><label class="field-label">Valor Líquido</label> {{ valorLiquido | currency: 'BRL'}} </p>
                </div>
                <div *ngIf="terminal" class="col-md-6 col-xs-12">
                  <p><label class="field-label">Terminal</label> {{terminal}} </p>
                </div>
                <div *ngIf="cartao" class="col-md-6 col-xs-12">
                  <p><label class="field-label">Cartão</label> {{cartao}} </p>
                </div>
                <div *ngIf="codigoAutenticacao" class="col-md-6 col-xs-12">
                  <p><label class="field-label">Código de Autenticação</label> {{codigoAutenticacao}} </p>
                </div>
                <div *ngIf="numeroComprovanteDeVenda" class="col-md-6 col-xs-12">
                  <p><label class="field-label">Comprovante de Venda</label> {{numeroComprovanteDeVenda}} </p>
                </div>
              </ng-container>

              <div class="col-md-6 col-xs-12">
                <p><label class="field-label">Forma de Pagamento</label> {{retornaPagamentoSelecionado(contaParcelaForm.get('tipoPagamento').value)}} </p>
              </div>
              <div *ngIf="observacaoPagamento" class="col-md-12">
                <p><label class="field-label">Observação</label> {{observacaoPagamento}} </p>
              </div>
              <div class="col-md-12" *ngIf="arquivoNome">
                <p><label class="field-label">Comprovante</label>
                  <a href="javascript:void(0)" (click)="baixarAnexo()">{{ arquivoNome }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="info-section" *ngIf="contaParcelaForm.get('boletoId').value > 0">
          <div class="section-header">
            <div [ngStyle]="{
                'color': boleto?.nossoNumero > 0 ? contaService.getColor(boleto.status) : '#f0f0f0',
                'cursor': boleto?.nossoNumero < 1 ? 'no-drop' : 'pointer'
              }" (click)="contaService.imprimirBoleto(contaParcelaForm.value)" [matTooltip]="ultimoLog?.textoLog">
              <mat-icon class="section-icon" fontSet="material-symbols-outlined">barcode_scanner</mat-icon>
            </div>
            <span class="section-title">Informações do Boleto</span>
          </div>
          <div class="section-content boleto-details">
            <label class="field-label">Linha Digitável</label>
            <code>{{boleto?.linhaDigitavel}}</code>
            <div class="row mt-2">
              <div class="col-md-6">
                <p><label class="field-label">Nosso Número</label> {{boleto?.nossoNumero}}</p>
              </div>
              <div class="col-md-6">
                <p><label class="field-label">Nosso Documento</label> {{boleto?.numeroDocumento}}</p>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </form>

  <!-- SubMenus -->
  <mat-menu #switchMenu>
    <button
     mat-menu-item
     (click)="confirmarSubstituicao()">
     Substituir por uma nova</button>
    <button
     mat-menu-item
     (click)="mapearSubstituicao()"
     >Substituir por uma existente</button>
  </mat-menu>
  <!--  -->
</mat-dialog-content>
